import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("circle", {
        cx: "17.5",
        cy: "17.5",
        r: "17",
        stroke: "#FFF"
      }),
      _createElementVNode("path", {
        fill: "#FFF",
        d: "M16 22.51V13l5.089 4.755z"
      })
    ], -1)
  ]))]))
}
export default { render: render }